// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"23b1b205","273":"9d3de0ba","451":"92ddea32","787":"a0e59ae2","959":"7ae71c8f"}[chunkId] + ".chunk.js";
};